import React, { useState } from 'react'
import { randomString } from '../../utils'
import { UploadedImgContainer } from '../../assets/styles'
import { processFile } from './fileUploadHelpers'
import { ThumbnailSuccess, ThumbnailDisabled } from '../../assets/img'
import 'styled-components/macro'

interface UploadImageProps {
	disabled?: boolean
	onChange?: (image: File | Blob, index?: number) => void
	index?: number
	readOnly?: boolean
}

export default function UploadImage(props: UploadImageProps): JSX.Element {
	const { disabled, onChange, index, readOnly } = props

	const [focus, setFocus] = useState(false)
	const inputId = randomString()

	const handleChangeChoiceImage = (e: any) => {
		const files = e.target.files

		if (files.length > 0 && onChange) {
			processFile(files[0], {
				onSuccess: (file: Blob) => onChange(file, index),
				onError: alert,
			})
		}
	}

	return (
		<UploadedImgContainer $disabled={disabled}>
			<label
				htmlFor={inputId}
				className={focus && !disabled ? 'label-focus' : ''}>
				<img src={`${disabled ? ThumbnailDisabled : ThumbnailSuccess}`} />
			</label>
			{!readOnly && (
				<input
					onFocus={() => setFocus(true)}
					onBlur={() => setFocus(false)}
					aria-label="Image Uploader"
					id={inputId}
					type="file"
					disabled={disabled}
					onChange={e => {
						setFocus(false)
						handleChangeChoiceImage(e)
					}}
					accept=".jpg,.png,.jpeg"
				/>
			)}
		</UploadedImgContainer>
	)
}
